import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import TestimonialsSection from '../components/TestimonialsSection';
import AboutSection from '../components/AboutSection';
import ProblemsSection from '../components/ProblemsSection';
import SolutionsSection from '../components/SolutionsSection';
import SolucoesSection from '../components/SolucoesSection';
import HowItWorksSection from '../components/HowItWorksSection';
import TargetAudienceSection from '../components/TargetAudienceSection';
import AuthoritySection from '../components/AuthoritySection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <TestimonialsSection />
        <AboutSection />
        <ProblemsSection />
        <SolutionsSection />
        <SolucoesSection />
        <HowItWorksSection />
        <TargetAudienceSection />
        <AuthoritySection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
